export default __webpack_public_path__ + "static/media/thumbnail3.62a51953.jpg";